import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { colorPalette } from '@next-common/mui';
import { EconomicOperatorInformation } from './EconomicOperatorInformation';
export const AvailableContent = ({ data }) => {
    return (React.createElement(Box, null,
        React.createElement(Stack, { sx: {
                padding: '16px',
                borderRadius: '8px',
                backgroundColor: colorPalette.gray100,
            } },
            React.createElement(Typography, { color: colorPalette.gray900, fontWeight: '600' }, "Personne responsable dans l\u2019UE"),
            React.createElement(Typography, { color: colorPalette.gray900, sx: {
                    marginTop: '8px',
                } }, "La Personne Responsable dans l\u2019UE ou \u201COp\u00E9rateur Economique\u201D, est la personne en charge de nombreux aspects de la conformit\u00E9 et de la s\u00E9curit\u00E9 d\u2019un produit sur le march\u00E9 europ\u00E9en. Si les informations d\u2019un vendeur sp\u00E9cifique n\u2019apparaissent pas ci-dessous, c\u2019est qu\u2019il n\u2019a pas encore transmis les coordonn\u00E9es de son op\u00E9rateur \u00E9conomique pour ce produit sp\u00E9cifique. Cette information peut \u00EAtre mise \u00E0 jour \u00E0 tout moment. La liste des vendeurs ayant renseign\u00E9 l\u2019op\u00E9rateur \u00E9conomique pour ce produit est la suivante :")),
        data && React.createElement(EconomicOperatorInformation, { data: data })));
};
